import { isEmpty } from 'lodash';
import { TypeContributeCompany } from 'src/features/CompanyDetail/Common/config';
import { ContributeTypes } from 'src/features/Contributions/config';
import { TypeContributePeople } from 'src/features/PeopleDetail/Common/config';
import { CommonResponse, CommonResponseList } from 'src/model/common';
import { ContributionNotes } from 'src/model/contribute';
import { deleteRequest, getRequest, postRequest, putRequest } from 'src/services/api/http';
import { URL_ENDPOINT } from 'src/utils/constants/service';
import { getArrayDefault } from 'src/utils/helpers/arrayHelpers';
import { handleQueryParams } from 'src/utils/helpers/queryParam';
import { IContributeDetailTypeMapping, IContributeTypeMapping } from 'src/utils/typings/response/contribute';

const ContributeService = {
  getContributions,
  getContributionById,
  getContributionNotes,
  createContributionComment,
  updateContributionComment,
  deleteContributionComment,
};

export default ContributeService;

function getContributions<T extends ContributeTypes>(type: T, query: Record<string, string | number>) {
  const url =
    type === ContributeTypes.People ? URL_ENDPOINT.contribute.listPeople : URL_ENDPOINT.contribute.listCompany;
  let typeContributeFilter = getArrayDefault(query.type) as Array<TypeContributeCompany | TypeContributePeople>;

  if (isEmpty(query.type)) {
    switch (type) {
      case ContributeTypes.Company:
        typeContributeFilter = Object.values(TypeContributeCompany).filter(
          (type) => type !== TypeContributeCompany.ReportWrongOtherContact,
        );
        break;
      case ContributeTypes.ReportWrong:
        typeContributeFilter = [TypeContributeCompany.ReportWrongOtherContact];
        break;
      case ContributeTypes.People:
        typeContributeFilter = Object.values(TypeContributePeople);
        break;
      default:
        break;
    }
  }
  const paramType = handleQueryParams('type', typeContributeFilter);
  return getRequest(url + `?${paramType}`, query, new CommonResponseList()) as Promise<
    IResponseList<IContributeTypeMapping[T]>
  >;
}

function getContributionById<T extends ContributeTypes>(type: T, dataId: string) {
  const url =
    type === ContributeTypes.People ? URL_ENDPOINT.contribute.detailPeople : URL_ENDPOINT.contribute.detailCompany;
  return getRequest(url.replace(':id', dataId), {}, new CommonResponse()) as Promise<
    IResponse<IContributeDetailTypeMapping[T]>
  >;
}

function getContributionNotes(id: string) {
  const url = URL_ENDPOINT.contribute.listNotes.replace(':id', id);
  return getRequest(url, {}, new ContributionNotes()) as Promise<ContributionNotes>;
}

function createContributionComment(payload: { dataUuid: string; noteId: number; body: { comment: string } }) {
  const url = URL_ENDPOINT.contribute.createCommentNote
    .replace(':data_uuid', String(payload.dataUuid))
    .replace(':note_id', String(payload.noteId));
  return postRequest(url, payload.body) as Promise<CommonResponse>;
}

function updateContributionComment(payload: {
  dataUuid: string;
  noteId: number;
  commentId: number;
  body: { comment: string };
}) {
  const url = URL_ENDPOINT.contribute.modifyCommentNote
    .replace(':data_uuid', String(payload.dataUuid))
    .replace(':note_id', String(payload.noteId))
    .replace(':comment_id', String(payload.commentId));
  return putRequest(url, payload.body) as Promise<CommonResponse>;
}

function deleteContributionComment(payload: { dataUuid: string; noteId: number; commentId: number }) {
  const url = URL_ENDPOINT.contribute.modifyCommentNote
    .replace(':data_uuid', String(payload.dataUuid))
    .replace(':note_id', String(payload.noteId))
    .replace(':comment_id', String(payload.commentId));
  return deleteRequest(url) as Promise<CommonResponse>;
}
